/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Assistant_Activity_Time_InInputs */



/**
* | output |
* | --- |
* | "In" |
*
* @param {Assistant_Activity_Time_InInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const assistant_activity_time_in = /** @type {((inputs?: Assistant_Activity_Time_InInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Assistant_Activity_Time_InInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Dans")
	if (locale === "de") return /** @type {LocalizedString} */ ("In")
	if (locale === "it") return /** @type {LocalizedString} */ ("In")
	if (locale === "ru") return /** @type {LocalizedString} */ ("В")
	if (locale === "es") return /** @type {LocalizedString} */ ("En")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("在")
	if (locale === "ja") return /** @type {LocalizedString} */ ("で")
	if (locale === "hi") return /** @type {LocalizedString} */ ("में")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Em")
	return /** @type {LocalizedString} */ ("In")
});